import React, { useState } from "react";
import calendericon from "../../assets/calendericon.svg";
import clock_black from "../../assets/clock_black.svg";
import { formatDateDutch } from "../../utils/formatDateDutch";
import StepsDisplay from "../StepsDisplay";
import Textarea from "../Textarea";
import arrow from "../../assets/arrow.svg";
import treatments from "../../data/behandelingen.json";
import check from "../../assets/check.svg";
import arrow_white from "../../assets/arrow_white.svg";
import return_icon from "../../assets/icon-return.svg";
import { handlePayment } from "../../redux/actions/handlePayment";
import SmallLoader from "../SmallLoader";
import { useDispatch, useSelector } from "react-redux";
import { addAppointment } from "../../redux/actions/appointments";
import { toast } from "alert";

const StepTwo = ({
  date,
  prevStep,
  nextStep,
  inputHandle,
  setInputHandle,
  progressWidth,
  step
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const startTime = inputHandle.appointmentTime.split("-")[0].trim();
  const [errors, setErrors] = useState({});
  const rawAppointmentId = localStorage.getItem("appointmentId");
  const storedInvoiceNumber = localStorage.getItem("appointmentInvoiceNumber");
  const appointmentId =
    rawAppointmentId &&
    rawAppointmentId !== "undefined" &&
    rawAppointmentId !== "null" &&
    storedInvoiceNumber === inputHandle.invoiceNumber
      ? rawAppointmentId
      : null;
  const fields2 = [
    {
      label: "firstName",
      type: "text",
      placeholder: "Voornaam*",
      name: "firstName",
      class: "col-6"
    },
    {
      label: "lastName",
      type: "text",
      placeholder: "Achternaam*",
      name: "lastName",
      class: "col-6"
    },
    // NEW FIELDS ADDED
    {
      label: "age",
      type: "text",
      placeholder: "Leeftijd*",
      name: "age",
      class: "col-6"
    },
    {
      label: "city",
      type: "text",
      placeholder: "Woonplaats*",
      name: "city",
      class: "col-6"
    },
    {
      label: "email",
      type: "email",
      placeholder: "E-mailadres*",
      name: "email",
      class: "col-12"
    },
    {
      label: "phoneNumber",
      type: "phoneNumber",
      placeholder: "Telefoonnummer*",
      name: "phoneNumber",
      class: "col-12"
    },
    {
      label: "note",
      type: "textarea",
      placeholder: "Opmerking",
      name: "note",
      class: "col-12",
      rows: 3
    }
  ];

  const validateFields = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/; // Exactly 10 digits
    const nameRegex = /^[A-Za-zÀ-ÿ\u00f1\u00d1\s'-]+$/;

    if (!inputHandle.firstName || !nameRegex.test(inputHandle.firstName)) {
      newErrors.firstName = "Ongeldige voornaam";
    }

    if (!inputHandle.lastName || !nameRegex.test(inputHandle.lastName)) {
      newErrors.lastName = "Ongeldige achternaam";
    }

    if (inputHandle.age && !/^\d{1,3}$/.test(inputHandle.age)) {
      newErrors.age = "Leeftijd moet een getal zijn";
    }

    if (!inputHandle.city || !nameRegex.test(inputHandle.city)) {
      newErrors.city = "Ongeldige woonplaats";
    }

    if (!inputHandle.email || !emailRegex.test(inputHandle.email)) {
      newErrors.email = "Ongeldig e-mailadres";
    }

    if (!inputHandle.phoneNumber || !phoneRegex.test(inputHandle.phoneNumber)) {
      newErrors.phoneNumber = "Telefoonnummer moet 10 cijfers bevatten";
    }

    if (!inputHandle.treatment || inputHandle.treatment === "") {
      newErrors.treatment = "Behandeling is verplicht";
    }

    return newErrors;
  };

  // const checks = [
  //   "Pijnloze behandeling",
  //   "Lichaamseigen stof",
  //   "15 jaar ervaring"
  // ];

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setInputHandle((prev) => ({
      ...prev,
      [name]: value
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined
    }));
  };

  const goToThirdStep = async () => {
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    const appointmentData = {
      ...inputHandle,
      timeslot:
        formatDateDutch(date).split(",")[0] + "-" + inputHandle.appointmentTime,
      appointmentDate:
        formatDateDutch(date).split(",")[1] + " " + new Date(date).getFullYear()
    };

    if (!appointmentId) {
      const result = await dispatch(addAppointment(appointmentData));
      const newId = result?.payload?.appointmentId;
      if (newId) {
        localStorage.setItem("appointmentId", newId);
        localStorage.setItem("appointmentInvoiceNumber", inputHandle.invoiceNumber);
      } else {
        toast.error("Kon afspraak niet aanmaken. Controleer uw verbinding en probeer opnieuw.");
        return;
      }
    }

    nextStep();
  };

  return (
    <div className="right">
      <div className="calender_container bevestiging_container">
        <div className="header-mobile">
          <h3 className="georgia-font fw-bold">Bevestiging</h3>
          <div className="return-mobile" onClick={prevStep}>
            <img src={return_icon} alt="" />
            <p>vorige stap</p>
          </div>
        </div>
        <br />
        <div className="mt-1">
          <div>
            <div className="margin-bottom-1">
              <h6 className="fw-600 mb-3">
                Bevestig dat je de volgende afspraak wilt inplannen
              </h6>
              <div
                onClick={prevStep}
                className="date_time d-flex align-items-center cursor-pointer"
              >
                <div className="d-flex align-items-center gap-3">
                  <img className="icon-small" src={calendericon} alt="" />
                  <h6 className="mb-0 fw-600">{formatDateDutch(date)}</h6>
                </div>
                <div className="center_line"></div>
                <div className="d-flex align-items-center gap-3">
                  <img className="icon-small" src={clock_black} alt="" />
                  <h6 className="mb-0 fw-600">{startTime} uur</h6>
                </div>
              </div>
            </div>
            <div>
              <h6 className="fw-600 mb-3">Behandeling*</h6>
              <div className="position-relative">
                <div className="select_container">
                  <img className="arrow" src={arrow} alt="" />
                  <select
                    name="treatment"
                    value={inputHandle.treatment || ""}
                    onChange={handleChange}
                    className={`form-control ${
                      errors.treatment ? "border-red" : ""
                    }`}
                  >
                    <option value="" disabled hidden>
                      Kies behandeling
                    </option>
                    {treatments.map((item, idxs) => (
                      <option key={idxs} value={item.title}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                {errors.treatment && (
                  <small className="text-danger">{errors.treatment}</small>
                )}
              </div>
            </div>
          </div>

          <div className="timetable_content">
            <div>
              {/* <h5 className="fw-600 mb-3">Reserveringskosten</h5> */}
              <p className="special">
                Voor het maken van een reservering wordt € 25,- in rekening
                gebracht. Dit bedrag wordt verrekend met de kosten van de
                behandeling. Betalen kan direct via iDeal bij het reserveren.
              </p>
              <p className="special">
                Toch verhinderd? Geen probleem, maar geef dit wel minstens 72
                uur van tevoren door. Bij te late of geen annulering worden de
                reserveringskosten ingehouden.
              </p>
            </div>

            {/* <div>
            <h5 className="netanyahu">
              Let op: na betaling is de volgende stap verplicht. De
              bevestigingsmail volgt daarna.
            </h5>
          </div> */}
            {/* <div>
            <img
              className="payment_img"
              src="/images/payment.png"
              alt=""
              width="230"
              height="63"
            />
          </div> */}

            {/* <div className="checks_container d-flex flex-column gap-2 py-2 px-3">
            {checks.map((item, idx) => (
              <div className="d-flex align-items-center gap-2" key={idx}>
                <img src={check} alt="" />
                <p className="body_text mb-0">{item}</p>
              </div>
            ))}
          </div> */}
          </div>
        </div>
      </div>
      <div className="timetable bevestiging_container_2">
        <div className="top_header">
          <div className="return" onClick={prevStep}>
            <img src={return_icon} alt="" />
            <p>vorige stap</p>
          </div>

          <StepsDisplay progressWidth={progressWidth} step={step} />
        </div>

        <div className="gegevens">
          <h6 className="fw-600 mb-3">Gegevens*</h6>
          <div className="container-fluid px-0">
            <div className="row gy-3">
              {fields2.map((content, idx) => (
                <div key={idx} className={`position-relative ${content.class}`}>
                  <Textarea
                    {...content}
                    value={inputHandle[content.name] ?? ""}
                    onChange={handleChange}
                    className={`form-control ${
                      errors[content.name] ? "border-red" : ""
                    }`}
                  />
                  {errors[content.name] && (
                    <small className="text-danger">
                      {errors[content.name]}
                    </small>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="d-flex gap-2 align-items-center">
          <button
            onClick={goToThirdStep}
            disabled={loading}
            className="payment_btn d-flex align-items-center justify-content-center gap-5"
          >
            laatste stap <img src={arrow_white} alt="" />
          </button>
          {loading && <SmallLoader />}
        </div>
      </div>
    </div>
  );
};

export default StepTwo;
